<template>
  <Teleport to="body">
    <TransitionGroup name="notification" tag="div" class="fixed top-5 right-5 z-[10000] flex flex-col gap-2 pointer-events-none">
      <div
        v-for="notification in notifications"
        :key="notification.id"
        :class="[
          'min-w-[300px] max-w-[400px] bg-surface rounded-md shadow-lg pointer-events-auto overflow-hidden',
          {
            'border-l-4 border-success': notification.type === 'success',
            'border-l-4 border-danger': notification.type === 'error',
            'border-l-4 border-info': notification.type === 'info',
            'border-l-4 border-warning': notification.type === 'warning'
          }
        ]"
      >
        <div class="flex items-center gap-3 p-3">
          <i :class="[
            'text-xl flex-shrink-0',
            getIcon(notification.type),
            {
              'text-success': notification.type === 'success',
              'text-danger': notification.type === 'error',
              'text-info': notification.type === 'info',
              'text-warning': notification.type === 'warning'
            }
          ]"></i>
          <span class="flex-1 text-text-main text-[0.9375rem] leading-normal">
            {{ notification.message }}
          </span>
          <button
            class="bg-transparent border-0 text-xl text-text-muted cursor-pointer p-0 w-6 h-6 flex items-center justify-center flex-shrink-0 transition-colors hover:text-text-main"
            @click="removeNotification(notification.id)"
          >
            &times;
          </button>
        </div>
      </div>
    </TransitionGroup>
  </Teleport>
</template>

<script setup lang="ts">
import { useNotification, type NotificationType } from '@/composables/useNotification'

const { notifications, removeNotification } = useNotification()

function getIcon(type: NotificationType): string {
  const icons = {
    success: 'fas fa-check-circle',
    error: 'fas fa-exclamation-triangle',
    info: 'fas fa-info-circle',
    warning: 'fas fa-exclamation-circle'
  }
  return icons[type] || icons.info
}
</script>

<style scoped>
/* Keep only transitions */
.notification-enter-active,
.notification-leave-active {
  transition: all 0.3s ease;
}

.notification-enter-from {
  opacity: 0;
  transform: translateX(100%);
}

.notification-leave-to {
  opacity: 0;
  transform: translateX(100%);
}

.notification-move {
  transition: transform 0.3s ease;
}
</style>

